module.exports = __webpack_public_path__ + "img/KarbalaRoad1.352283c0.jpg";